import { DAO } from "./DAO";
import { F05Cache } from "./F05Cache";


export class F05CacheDAO {

  static async FetchByMemberGuid(member_guid: string): Promise<F05Cache | null> {
    let rslt = await DAO.Select(F05Cache, " WHERE member_guid='" + member_guid + "' ");

    if (rslt.length == 0) {
      return null;
    } else if (rslt.length == 1) {
      return rslt[0];
    } else {
      throw new Error("857867 重複的 member_guid: " + member_guid + " !!!");
    }

  }

  static async Insert(data: F05Cache): Promise<F05Cache> {
    let refetch_data = await DAO.Insert(F05Cache, data);
    return refetch_data;
  }

  static async Delete(data: F05Cache): Promise<number> {
    let effect_rows_cnt = DAO.DeleteByGuid(F05Cache, data.guid);
    return effect_rows_cnt;
  }

}